import { Injectable, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { environment } from 'src/environments/environment';
import { HomeComponent } from './pages/home/home.component';
import { AuthGuard } from './shared/auth.guard';
import { LoginComponent } from './layout/login/login.component';

const titleSuffix = ' - ' + environment.appTitle;

const routes: Routes = [
  { path: '', canActivate: [AuthGuard], component: HomeComponent, title: 'Home' + titleSuffix },
  // top menu
  { path: 'cart', canActivate: [AuthGuard], component: HomeComponent, title: 'Cart' + titleSuffix },
  { path: 'settings', canActivate: [AuthGuard], component: HomeComponent, title: 'Settings' + titleSuffix },
  { path: 'messages', canActivate: [AuthGuard], component: HomeComponent, title: 'Messages' + titleSuffix },

  // login
  { path: 'login', component: LoginComponent, title: 'Login' },

  // feature modules
  { path: 'products', canActivate: [AuthGuard], loadChildren: () => import('./pages/products/products.module').then(m => m.ProductsModule), title: 'Products' + titleSuffix },
  { path: 'sales', canActivate: [AuthGuard], loadChildren: () => import('./pages/sales/sales.module').then(m => m.SalesModule), title: 'Sales' + titleSuffix },
  { path: 'stock', canActivate: [AuthGuard], loadChildren: () => import('./pages/stock/stock.module').then(m => m.StockModule), title: 'Stock' + titleSuffix },
  { path: 'claims', canActivate: [AuthGuard], loadChildren: () => import('./pages/claims/claims.module').then(m => m.ClaimsModule), title: 'Claims' + titleSuffix },
  { path: 'rebates', canActivate: [AuthGuard], loadChildren: () => import('./pages/rebates/rebates.module').then(m => m.RebatesModule), title: 'Rebates' + titleSuffix },
  { path: 'admin', canActivate: [AuthGuard], loadChildren: () => import('./pages/admin/admin.module').then(m => m.AdminModule), title: 'Admin' + titleSuffix },

  // fallback
  { path: '**', redirectTo: '/' }

];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
